import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { useToast } from "vue-toastification";
  import store from "@/store";
  import router from "@/router";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SetExpirationDateHoldRequestModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lotTitle: {
      type: String,
      required: true,
    },
    initialHold: {
      type: Object,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      required: false,
      default: false,
    },
    customText: {
      type: String,
      required: false,
      default: "",
    },
    customTitle: {
      type: String,
      required: false,
      default: "Hold Duration",
    },
    minExpirationDays: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  emits: ["close", "submit"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const buttonText = computed(() =>
    props.isSubmitting ? "Wait..." : "Confirm"
  );
  const modalText = computed(() =>
    props.customText
      ? props.customText
      : `Please set the duration of the Hold for Lot ${props.lotTitle}`
  );

  const toast = useToast();
  const expirationDateForm = ref(`${props.minExpirationDays}`);
  const onClose = () => {
    emits("close");
  };

  const onDaysChange = (e: Event) => {
    const operation = (e.target as HTMLInputElement).name;
    let currentValue = expirationDateForm.value
      ? parseInt(expirationDateForm.value)
      : 0;

    if (operation === "plus" && currentValue < 99) {
      currentValue++;
    } else if (operation === "minus" && currentValue > 1) {
      currentValue--;
    }

    expirationDateForm.value = currentValue.toString();
  };

  const submit = (value: string) => {
    const regex = /^\d+$/;
    const valueAsNumber = parseInt(value.trim());

    if (valueAsNumber < props.minExpirationDays) {
      toast.error(
        `The hold duration must be at least ${props.minExpirationDays} day`,
        { timeout: 2000 }
      );
    } else if (!regex.test(value)) {
      toast.error("The value can only be a number", { timeout: 2000 });
    } else {
      emits("submit", valueAsNumber);
    }
  };

const __returned__ = { emits, props, buttonText, modalText, toast, expirationDateForm, onClose, onDaysChange, submit, ref, computed, Modal, get useToast() { return useToast }, get store() { return store }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})